import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ActionCreator from "../store/actions/index";
import AlertsList from '../components/DashboardComponents/AlertTableComponent/AlertsList';
import { Grid, withStyles } from '@material-ui/core/';
import { compose } from 'recompose';
import CountUpValue from "../components/DashboardComponents/CountUpValue/CountUpValue";
import CountEcoValue from "../components/DashboardComponents/CountEcoValue/CountEcoValue";
import barChartBlue from "../images/barChartBlue.png";
import barChartGreen from "../images/barChartGreen.png";
import barChartPurple from "../images/barChartPurple.png";
import CircularGauge from '../components/DashboardComponents/CircularGaugeComponent/CircularGauge';
import ValueIndicator from '../components/DashboardComponents/ValueIndicatorComponent/ValueIndicator';
import EcoGradeTopList from "../components/DashboardComponents/EcoTopList";
import TrophyTopList from "../components/DashboardComponents/TrophyTopComponent/TrophyTopList";
import t from "../languages/pl";
import {withRouter} from 'react-router-dom';

const useStyles = (theme => ({
    container: {
        width: "90%",
        margin: "auto",
        marginTop: theme.spacing(3)
    },
    divider: {
        marginTop: theme.spacing(2)
    },
    title: {
        marginLeft: 10
    }
}));

class Dashboard extends Component {

    componentDidMount() {
        this.apiCalls();
    }
    apiCalls() {
        this.props.getTotalDistance();
        // this.props.getTotalFuelUsage();
        this.props.getEcoRoutesValues();
        this.props.getTotalDriveTime();
        this.props.getPrivateDriveTime();
        this.props.getCarsInService();
        this.props.getAlertList();
        this.props.getEcoGradeList();
        this.props.getTopTrophyList();
    }

    fetchCarsCountInServiceData(data) {
        let count = 0;
        if (data.blokada != null) {
            count = data.blokada.liczba + data.serwis.liczba + data.panic.liczba;
        }
        return count;
    }

    onEcoCarRegistrationClick(data) {
        this.props.resetToDefaults();
        this.props.history.push({
            pathname: "/cars",
            search: `?ids=${data.rejestracja}`
        });
    }

    onEcoDriverClick(data) {
        this.props.history.push({
            pathname: "/drivers",
            search: `?id=${data.kierowca_id}`
        });
    }

    render() {
        const { classes, averageMileage, fuelUsage, ecoRoutesValues,
            totalDriveTime, privateDriveTime,
            inServiceList, ecoCars,
            ecoDrivers, alerts, topTrophy } = this.props;

        return (
            <div className={classes.container}>
                <Grid container >
                    <Grid item xs={12} md={6} lg={4} className={classes.gridCell}>
                        <CountUpValue
                            value={averageMileage.dystans}
                            units="km"
                            barChartImg={barChartBlue}
                            data={averageMileage}
                            averageMileage
                        />
                    </Grid>
                    <Grid item xs={12} md={6} lg={4}>
                        <CountUpValue
                            decimals={1}
                            units="h"
                            barChartImg={barChartGreen}
                            data={totalDriveTime}
                            averageDriveTime
                        />
                    </Grid>
                    <Grid item xs={12} md={6} lg={4}>
                        <CountEcoValue
                            units="km"
                            barChartImg={barChartPurple}
                            data={ecoRoutesValues}
                            combustionForFleet
                        />
                    </Grid>
                </Grid>
                <Grid container direction="row">
                    <Grid item sm={12} md={12} lg={4}>
                        <Grid item sm={12}>
                            <TrophyTopList
                                title={t.trophyTopRating}
                                data={topTrophy}
                                attrName="kierowca"
                                headerLabel={t.driver}
                                onElementClick={(data) => this.onEcoDriverClick(data)}
                            />
                            <div className={classes.divider} />
                            <CircularGauge
                                value={privateDriveTime.czas * 100}
                            />
                            <div className={classes.divider} />
                            <ValueIndicator
                                title={t.carsInServiceMode}
                                value={this.fetchCarsCountInServiceData(inServiceList)}
                                data={inServiceList}
                                btnVisible={this.fetchCarsCountInServiceData(inServiceList) > 0}
                            />
                        </Grid>
                    </Grid>
                    <Grid item sm={12} md={8}>
                        <Grid container direction="row">
                            <Grid item xs={12} md={12} lg={6}>
                                <EcoGradeTopList
                                    title={t.carsEcoRating}
                                    data={ecoCars}
                                    attrName="etykieta"
                                    headerLabel={t.car}
                                    onElementClick={(data) => this.onEcoCarRegistrationClick(data)}
                                />
                            </Grid>
                            <Grid item xs={12} md={12} lg={6}>
                                <EcoGradeTopList
                                    title={t.driversEcoRating}
                                    data={ecoDrivers}
                                    attrName="kierowca"
                                    headerLabel={t.driver}
                                    onElementClick={(data) => this.onEcoDriverClick(data)}
                                />
                            </Grid>
                            <Grid item xs={12} md={12} lg={12}>
                                <AlertsList
                                    data={alerts}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        averageMileage: state.dashboardReducer.averageMileage,
        // fuelUsage: state.dashboardReducer.fuelUsage,
        ecoRoutesValues: state.dashboardReducer.ecoRoutesValues,
        totalDriveTime: state.dashboardReducer.totalDriveTime,
        privateDriveTime: state.dashboardReducer.privateDriveTime,
        inServiceList: state.dashboardReducer.inServiceList,
        ecoCars: state.dashboardReducer.ecoCars,
        ecoDrivers: state.dashboardReducer.ecoDrivers,
        alerts: state.dashboardReducer.alerts,
        topTrophy: state.dashboardReducer.topTrophyList
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreator, dispatch);
};

Dashboard.propTypes = {
    classes: PropTypes.object,
    //redux
    averageMileage: PropTypes.object,
    // fuelUsage: PropTypes.object,
    ecoRoutesValues: PropTypes.object,
    totalDriveTime: PropTypes.object,
    privateDriveTime: PropTypes.object,
    inServiceList: PropTypes.object,
    ecoCars: PropTypes.object,
    ecoDrivers: PropTypes.object,
    alerts: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    topTrophy: PropTypes.object,
    getTotalDistance: PropTypes.func,
    getTotalFuelUsage: PropTypes.func,
    getEcoRoutesValues: PropTypes.func,
    getTotalDriveTime: PropTypes.func,
    getPrivateDriveTime: PropTypes.func,
    getCarsInService: PropTypes.func,
    getAlertList: PropTypes.func,
    getEcoGrade: PropTypes.func,
    getEcoGradeList: PropTypes.func,
    resetToDefaults: PropTypes.func,
    getTopTrophyList: PropTypes.func,
    //router
    history: PropTypes.object
};

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps
    ),
    withStyles(useStyles),
    withRouter
)(Dashboard);
